module.exports = __webpack_public_path__ + "img/updates.9060ec90.svg";